import { Component, ComponentInterface, h, JSX, Prop } from '@stencil/core';
import { DataSpaKey } from 'app/shared/models/dataSpa';
import { store } from 'app/shared/store/store';
import { StoreKeys } from 'app/shared/constants/store-keys.enum';
import { getDataSpaSearchParams } from 'app/shared/utilities/helper-functions';

@Component({
  tag: 'app-products-container',
  shadow: false
})
export class ProductCardsContainer implements ComponentInterface {
  @Prop() dataSpa: string;

  public render(): JSX.Element {
    const guidedFlowActiveCategory = store.get(StoreKeys.guidedFlowActiveCategory);
    if (this.dataSpa) {
      const spaParams = getDataSpaSearchParams(this.dataSpa);
      const mode = spaParams.get(DataSpaKey.mode);
      const focusSku = spaParams.get(DataSpaKey.focusSku);
      const dataSpaCouponCode = spaParams.get(DataSpaKey.couponCode);
      const mobileCouponCode = spaParams.get(DataSpaKey.mobileCouponCode);
      const nbnCouponCode = spaParams.get(DataSpaKey.nbnCouponCode);
      let host = '';
      if (mode === 'publish') {
        host = '/apps/comparison';
      } else {
        host = spaParams.get(DataSpaKey.host);
      }
      if (guidedFlowActiveCategory && !['none', 'energy'].includes(guidedFlowActiveCategory)) {
        let couponCode = dataSpaCouponCode;
        if (mobileCouponCode && guidedFlowActiveCategory === 'mobile plan') {
          couponCode = mobileCouponCode;
        } else if (nbnCouponCode && guidedFlowActiveCategory === 'nbn') {
          couponCode = nbnCouponCode;
        }
        const dataSpa = `host=${host}&productcategory=${guidedFlowActiveCategory}&focusSku=${focusSku}&isGuidedFlow=true${
          couponCode ? `&couponCode=${couponCode}` : ''
        }`;
        return <app-product-cards data-spa={dataSpa} />;
      }
      return null;
    }
  }
}
